<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card class="card-profile mt--300" no-body shadow>
          <div class="px-4">
            <div class="text-center mt-5">
              <h3>لینک به‌اشتراک‌گذاری</h3>

              <div class="mt-4" style="text-align: justify">این لینک را می‌توانید برای کسی که می‌خواهید پیام را مشاهده
                کند ارسال کنید.
              </div>

              <div class="input-group mb-3" dir="ltr">
                <input :value="'https://safenote.radisam.ir/p/' + $route.params.hash" class="form-control" dir="ltr"
                       placeholder="آدرس لینک" readonly type="text">
                <div class="input-group-append">
                  <button v-if="false" class="btn btn-outline-secondary" type="button" @click="copyEvent">کپی</button>
                  <button class="btn btn-outline-secondary" type="button" @click="shareEvent">...به‌اشتراک‌گذاری
                  </button>
                </div>
              </div>
              <router-link class="nav-link" to="/private-message"> <!--TODO this make the whole row clickable!-->
                <base-button type="neutral">ایجاد پیام جدید</base-button>
              </router-link>

              <div/>
              <br>

            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>

<script>
import Inputs from "./components/Inputs";
import BaseDropdown from "../components/BaseDropdown";

export default {
  components: {
    Inputs,
    BaseDropdown
  },
  data() {
    return {
      showMore: false
    }
  },
  methods: {
    copyEvent() {
      navigator.clipboard.writeText('https://safenote.radisam.ir/p/' + this.$route.params.hash);
    },
    shareEvent() {
      if (navigator.share) {
        navigator.share({
          title: `به اشتراک گذاری لینک پیام خصوصی`,
          url: 'https://safenote.radisam.ir/p/' + this.$route.params.hash,
        }).then(() => {
          //Do Nothing
        }).catch(console.error)
      } else {
        alert('Navigator does not support share.')
      }
    },
  }
};
</script>

<style scoped>
.dropdown {
  display: block;
}

.dropdown .btn {
  width: 100%;
  display: block;
}

</style>
